import { gql } from '@apollo/client';

export default gql`
  fragment NotificationMessageDTO on NotificationMessageDTO {
    userId
    uuid
    receivedTime
    subject
    message
    actionSteps {
      description
      link
    }
    attachments {
      fileName
      link
      mimeType
    }
    isRead
  }
`;
